const actions = {
  async logout({ dispatch }) {
    await dispatch('cs-session/logout', undefined, { root: true });
  }
};

export default actions;
